import PropTypes from "prop-types";
import { useEffect, useState, useRef } from "react";
import Link from "next/link";
import useImageWrapper from "helpers/hooks/useImageWrapper";
import Photo from "components/shared/stays/Photo";
import Title from "components/shared/stays/Title";
import Text from "components/shared/stays/Text";
import styles from "components/shared/stays/CollectionCard.module.scss";

export default function CollectionCard({ name, slug, numTrips, imageUrl }) {
  const { getImageWidth } = useImageWrapper();
  const [imgWidths, setImgWidths] = useState([0]);
  const imgWrapperRef = useRef(null);

  useEffect(() => {
    const calculatedWidth = getImageWidth([imgWrapperRef]);
    setImgWidths(calculatedWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Link href={`/collections/${slug}`} className={styles.component}>
      <div className={styles.description}>
        <Title size={5} font="cushing" className={styles.name}>
          {name}
        </Title>
        <Text size={3} className={styles.meta}>
          {`${numTrips} stays`}
        </Text>
      </div>
      <div className={styles.visual} ref={imgWrapperRef}>
        {imageUrl && (
          <Photo
            src={imageUrl}
            alt={name}
            layout="fill"
            objectFit="cover"
            placeholder
            containerWidth={imgWidths[0]}
          />
        )}
      </div>
    </Link>
  );
}

CollectionCard.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  numTrips: PropTypes.number.isRequired,
  imageUrl: PropTypes.string.isRequired,
};
